import { render, staticRenderFns } from "./TableMundialSlider.vue?vue&type=template&id=3fd052d4&"
import script from "./TableMundialSlider.vue?vue&type=script&lang=js&"
export * from "./TableMundialSlider.vue?vue&type=script&lang=js&"
import style0 from "./TableMundialSlider.vue?vue&type=style&index=0&id=3fd052d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports